import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getPhysiciansList } from "../../../../../../services/tasyPhysician.service";
import { Grid } from "@mui/material";

const translationPath = "4uESign.page.automations.automationRules.";

export const PhysiciansAutoComplete = memo(() => {
  const { t } = useTranslation();
  const [physicians, setPhysicians] = useState<ISelectType[]>([]);
  const [searchBy, setSearchBy] = useState<string>("");
  const { sendRequest: getPhysiciansListReq } = useFetch(getPhysiciansList);

  const handleFetchPhysicians = useCallback(async () => {
    if (!searchBy || searchBy?.trim() === "" || searchBy.length < 3) return;
    const { data, success } = await getPhysiciansListReq({
      SearchBy: searchBy,
      EnableCode: true,
    });
    if (success && data) {
      const mappedItems: ISelectType[] = data.map((item) => {
        return {
          id: item.identifier,
          name: item.individualName,
          code: item.identifier,
        };
      });
      setPhysicians(mappedItems);
    }
  }, [getPhysiciansListReq, searchBy]);

  useEffect(() => {
    handleFetchPhysicians();
  }, [handleFetchPhysicians]);

  const handleSetSearchBy = useCallback((search: string) => {
    setSearchBy(search);
  }, []);

  return (
    <Grid item xs={12} sm={12}>
      <AutoCompleteMulti
        name="physicians"
        label={t(translationPath + "physicians")}
        size="small"
        options={physicians}
        SearchAsYouTypeParams={handleSetSearchBy}
      />
    </Grid>
  );
});
